import React, {Component} from 'react';
import PropTypes from 'prop-types'
import i18next from 'i18next'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import EncryptContainer from "../../containers/EncryptContainer"
import DecryptContainer from "../../containers/DecryptContainer"
import KeyGenerator from "../../containers/KeyGeneratorContainer"
import CreateVerifyTSContainer from "../../containers/CreateVerifyTSContainer"
import CertificateInfoSignature from "./CertificateInfoSignature"
import CertificateInfoKeyAgreement from "./CertificateInfoKeyAgreement"

class Tabs extends Component {
    constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected,
      dropdownShow: false,
      tabIndex: null,
      selectedTab: [<EncryptContainer />, <DecryptContainer />, <KeyGenerator />, <CertificateInfoSignature />, <CertificateInfoKeyAgreement />, <CreateVerifyTSContainer />]
    }
    this.showMenu = this.showMenu.bind(this);
    this.closeMenu = this.closeMenu.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.base.createDs !== prevProps.base.createDs) {
      this.setState({selected: 0}, () => {this.setState({tabIndex: null})});
    }
  }

  getDefaultProps() {
    return {
      selected: 0
    };
  }
  getInitialState() {
    return {
      selected: this.props.selected
    };
  }

  showDropdown(event) {
    event.preventDefault();
    this.setState({
      dropdownShow: !this.state.dropdownShow
    }, () => {
        document.addEventListener('click', this.closeMenu);
    });
  }

  showMenu(event) {
    event.preventDefault();
    
    this.setState({ dropdownShow: true }, () => {
      document.addEventListener('click', this.closeMenu);
    });
  }

  closeMenu(event) { 
      this.setState({ dropdownShow: false }, () => {
        document.removeEventListener('click', this.closeMenu);
      });  
  }

  handleClick(index, tab, event) {
    if (event === undefined) {
      event = tab;
      this.setState({
        tabIndex: null
      });
    } else {
      this.setState({
        tabIndex: tab
      });
    }
    event.preventDefault();
    this.setState({
      selected: index
    });
  }
  propTypes: {
    selected: PropTypes.number,
    children: PropTypes.array,
    children: PropTypes.element
  }
  _renderTitles() {
    function labels(child, index) {
      let activeClass = (this.state.selected === index ? 'nav-link active' : 'nav-link');
      return (
        (child !== null && index !== 2) ?
          <li key={index} className="nav-item">
            <a href={null} style={{"cursor": "pointer"}}
              className={activeClass}
              onClick={this.handleClick.bind(this, index)}>
              {child.props.label}
            </a>
          </li>
        : (index === 2) 
        ? <li key={index} className={this.state.dropdownShow ? "nav-item dropdown show" : "nav-item dropdown"} style={{"cursor": "pointer"}}>
            <a className={(this.state.tabIndex !== null) ? "nav-link dropdown-toggle active" : "nav-link dropdown-toggle"} data-toggle="dropdown" href={null} aria-haspopup="true" onClick={this.showMenu}>{child.props.label}</a>
              <div className={this.state.dropdownShow ? "dropdown-menu  show" : "dropdown-menu"}>
                {
                  this.props.base.encrypt ? <a href={null} style={{"cursor": "pointer"}}
                  className="dropdown-item"
                  onClick={this.handleClick.bind(this, index, 0)}>{i18next.t("encrypt" : "encrypt")}</a>
                  : null
                }
                {
                  this.props.base.decrypt ? <a href={null} style={{"cursor": "pointer"}}
                  className="dropdown-item"
                  onClick={this.handleClick.bind(this, index, 1)}>{i18next.t("decrypt" : "decrypt")}</a>
                  : null
                }
                {
                  this.props.base.keyGenerator ? <a href={null} style={{"cursor": "pointer"}}
                  className="dropdown-item"
                  onClick={this.handleClick.bind(this, index, 2)}>{i18next.t("keysGeneration" : "keysGeneration")}</a>
                  : null
                }
                {
                  this.props.base.certInfoSignature ? <a href={null} style={{"cursor": "pointer"}}
                  className="dropdown-item"
                  onClick={this.handleClick.bind(this, index, 3)}>{i18next.t("signatureCertificate" : "signatureCertificate")}</a>
                  : null
                }
                {
                  this.props.base.certInfoKeyAgreement ? <a href={null} style={{"cursor": "pointer"}}
                  className="dropdown-item"
                  onClick={this.handleClick.bind(this, index, 4)}>{i18next.t("encryptionCertificate" : "encryptionCertificate")}</a>
                  : null
                }
                {
                  this.props.base.createVerifyTs ? <a href={null} style={{"cursor": "pointer"}}
                  className="dropdown-item"
                  onClick={this.handleClick.bind(this, index, 5)}>{i18next.t("timestamp" : "timestamp")}</a>
                  : null
                }
              </div>
          </li>
        : null
      );
    }
    return (
      <ul className="nav nav-tabs">
        {this.props.children.map(labels.bind(this))}
      </ul>
    );
  }
  _renderContent() {
    return (
      <div>
        {
          this.state.tabIndex !== null
          ? this.state.selectedTab[this.state.tabIndex]
          : this.props.children[this.state.selected]
        }
      </div>
    );
  }
  render() {
    return (
      <div>
        {this._renderTitles()}
        {this._renderContent()}
      </div>
    );
  }
}
function mapStateToProps(state) {
    return {
        locales: state.i18n,
        localesReducer: state.localesReducer,
        base: state.base
    }
}

const mapDispatchToProps = (dispatch) => {
    const actions = {
    };
    return {
       actions: bindActionCreators(actions, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Tabs);


// WEBPACK FOOTER //
// ./src/components/body/Tabs.js